import { Component, inject } from '@angular/core';
import { NewCustomerService } from '../../../services/new-customer.service';

// Ragione sociale, codice fiscale e partita IVA del cliente in inserimento
@Component({
  selector: 'ord-new-customer-header',
  template: `
    @if (registry(); as registry) {
      <div class="registry-card">
        <span class="registry-name headline-small-emphasized">{{ registry.ragioneSociale }}</span>
        <div class="registry-field">
          <span class="body-large-emphasized">Codice Fiscale</span>
          <span class="body-large">{{ registry.codiceFiscale || '—' }}</span>
        </div>
        <div class="registry-field">
          <span class="body-large-emphasized">Partita IVA</span>
          <span class="body-large">{{ registry.partitaIva || '—' }}</span>
        </div>
      </div>
    }
  `,
  styles: `
    :host {
      display: block;
    }

    .registry-card {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: var(--mat-sys-spacing-24);
      padding: var(--mat-sys-spacing-16);
      border-radius: var(--mat-sys-corner-medium);
      color: var(--mat-sys-on-surface);
      background-color: var(--mat-sys-surface-container-low);
    }

    .registry-name {
      grid-column: 1 / -1;
      overflow-wrap: anywhere;
    }

    .registry-field {
      display: grid;
      gap: var(--mat-sys-spacing-8);
      overflow-wrap: anywhere;
    }
  `,
})
export class NewCustomerHeader {
  readonly registry = inject(NewCustomerService).registry;
}
